import { Outlet } from 'react-router-dom'
import { colors, font } from '../styles/tokens'

// Gate 3 (Option B): this module no longer renders its own Sidebar or
// user/sign-out controls -- those duplicated CostSpace's own 60px rail +
// 200px panel and its account menu, which already surround this module
// when it's mounted at estimation/* inside CostSpace's shell. The layout
// this file is actually responsible for (main's padding/flex) is unchanged.
//
// Breadcrumb integration: CostSpace's own breadcrumb (App.jsx) now shows
// "Tender Workspace" / "Revision" in place of the static "Estimation"
// label whenever the URL is inside those contexts, so this module's
// TopBar no longer renders its own second Breadcrumbs bar -- one
// breadcrumb, not two.
export default function AppShell() {
  return (
    <div style={{ fontFamily: font.family, minHeight: '100vh', display: 'flex', background: colors.bg }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <main style={{ padding: '24px 32px', flex: 1 }}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}
